class MenuDrawerMobile extends HTMLElement {
  constructor() {
    super();
    this.submenuLevel1 = this.querySelectorAll('.menu-drawer__navigation .submenu__level-1');
    this.primaryMenuItems = this.querySelectorAll('.menu-drawer__menu > li > .menu-drawer__menu-item:not(a)');
    this.setFeatured();
    this.bindEvents();
  }

  setFeatured() {
    this.submenuLevel1.forEach((item) => {
      item.querySelectorAll('[data-link-featured]')?.forEach((itemLvl2) => {
        itemLvl2.querySelector('.menu-drawer__menu-item')?.setAttribute('aria-expanded', true);
      });
    });
  }

  bindEvents() {
    this.primaryMenuItems.forEach((item) => item.addEventListener('click', this.onMenuItemClick.bind(this)));
  }

  onMenuItemClick(event) {
    const menuItemElement = event.currentTarget;

    setTimeout(() => {
      this.openMenuDrawer(menuItemElement);
    }, 50);
  }

  openMenuDrawer(menuItemElement) {
    if (menuItemElement?.parentNode?.parentNode?.classList?.contains('menu-drawer__menu-1')) {
      const menuItems = menuItemElement?.closest('.menu-drawer__menu')?.querySelectorAll('li > .menu-drawer__menu-item:not(a)');
      menuItems.length && menuItems.forEach(item => {
        if (item.hasAttribute('aria-expanded')) {
          const linkHandle = item.getAttribute('data-link-handle');
          const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
          submenuLevel1?.removeAttribute('aria-expanded');
          item.removeAttribute('aria-expanded');
        }

        if(item.parentNode?.dataset?.linkFeatured != undefined) {
          item.setAttribute('aria-expanded', true);
        }
      });
    }

    if (menuItemElement.hasAttribute('aria-expanded')) {
      const linkHandle = menuItemElement.getAttribute('data-link-handle');
      const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
      menuItemElement?.removeAttribute('aria-expanded');
      submenuLevel1?.removeAttribute('aria-expanded');
    } else {
      const linkHandle = menuItemElement.getAttribute('data-link-handle');
      const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
      menuItemElement?.setAttribute('aria-expanded', true);
      submenuLevel1?.setAttribute('aria-expanded', true);
    }
  }
}

customElements.define('menu-drawer-mobile', MenuDrawerMobile);
